import Client from './axiosClient'
const resourceInit = '/suggested-master'
const postMove = '/suggested-master'
const priceStatus = '/price-status'

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  priceStatusInit() {
    return Client.get(`${priceStatus}`);
  },
  
  post(payload) {
    return Client.post(`${postMove}`, payload);
  },
  postPrice(payload) {
    return Client.post(`${priceStatus}`, payload);
  }


  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/Misc.js